var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHandpet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 196,
    viewBox: "0 0 189 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.7957 194.381C146.263 194.381 187.986 152.389 187.986 100.589C187.986 48.7882 146.263 6.79578 94.7957 6.79578C43.3279 6.79578 1.60498 48.7882 1.60498 100.589C1.60498 152.389 43.3279 194.381 94.7957 194.381Z",
    fill: "#FF3239",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_878_2618",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 189,
    height: 191
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7957 194.381C146.263 194.381 187.986 152.389 187.986 100.589C187.986 48.7882 146.263 6.79578 94.7957 6.79578C43.3279 6.79578 1.60498 48.7882 1.60498 100.589C1.60498 152.389 43.3279 194.381 94.7957 194.381Z",
    fill: "#FF3234",
    stroke: "#FF3234",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_878_2618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.1 133.516L173.236 135.254C171.064 139.628 168.891 144.002 166.718 148.375",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.407 132.9L174.1 133.516",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.365 122.905L178.418 124.825",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.113 207.502C139.113 202.077 138.152 195.713 140.632 190.751C142.679 186.672 146.816 185.102 150.395 182.649C156.481 178.457 162.596 174.308 168.654 170.089C173.195 166.935 177.011 164.285 179.476 159.085L179.574 158.86L187.763 140.413L192.916 128.792C194.657 124.867 196.482 121.559 194.393 117.312C192.68 113.821 189.239 112.994 185.674 114.018C182.206 115.027 180.799 119.989 179.351 122.919",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.342 207.502C111.342 196.778 109.837 184.905 114.406 174.967C118.473 166.122 125.896 161.552 133.668 156.491C136.3 154.781 138.933 153.071 141.551 151.333C147.15 147.632 155.869 140.441 162.679 145.109C162.679 145.109 171.718 150.31 162.679 156.477L143.306 170.453",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.607 118.055C179.616 117.466 177.457 117.368 175.423 117.732C173.571 118.069 172.29 118.461 170.771 119.625C168.919 121.04 166.663 124.601 165.562 126.704C164.379 128.975 163.306 131.301 162.178 133.6C160.548 136.923 158.905 140.245 157.275 143.567",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.075 127.306C165.075 127.306 160.353 124.559 155.757 127.685C151.885 130.306 145.673 146.16 144.183 149.539",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.15 43.1859C117.15 43.1859 90.1296 37.2984 76.1044 43.1158C76.1044 43.1158 42.817 44.4755 39.1958 69.9598C39.1958 69.9598 48.6388 86.8372 54.5581 87.8745C60.4774 88.9118 58.82 94.0423 58.82 94.0423L64.6697 105.747L66.9956 131.876L58.82 128.82L54.8924 130.054L55.3938 148.403L58.0122 151.557L85.812 153.66L90.1575 148.403H100.102L105.213 151.894L129.893 151.501L135.771 137.091L139.323 120.087V104.626H133.598L129.044 112.434L125.59 115.63V104.626L131.495 90.5939L152.011 69.5673C152.011 69.5673 144.921 46.7464 117.177 43.1999L117.15 43.1859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6699 105.733C64.6699 105.733 64.9903 151.88 76.9403 151.88C78.7927 151.88 84.1966 151.88 85.0462 151.88C89.3081 151.922 90.1577 148.613 90.1577 144.254V117.732",
    stroke: "#FF3239",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8397 134.442C65.8397 134.442 60.5889 128.919 60.575 128.919C58.7087 126.956 55.7421 127.391 54.8925 130.04C54.3772 131.638 54.6139 139.376 54.6 141.394C54.5721 144.983 54.4747 149.342 58.0123 151.543C59.224 152.3 62.4553 152.09 64.5584 152.104C68.4999 152.104 72.4415 152.104 76.383 152.104",
    stroke: "#FF3239",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.297 151.417C114.67 151.725 114.002 151.88 113.305 151.88C111.453 151.88 106.049 151.88 105.199 151.88C100.937 151.922 100.088 148.613 100.088 144.254V117.732",
    stroke: "#FF3239",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.562 105.733C125.562 105.733 125.451 121.349 123.013 134.413",
    stroke: "#FF3239",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.991 136.544C124.991 136.544 117.916 128.918 117.902 128.904C116.035 126.942 113.069 127.377 112.219 130.026C111.704 131.624 111.941 139.362 111.927 141.38C111.899 144.969 111.801 149.328 115.339 151.529C116.551 152.286 119.782 152.076 121.885 152.09C123.222 152.09 124.573 152.09 125.91 152.09C126.551 152.09 127.191 152.104 127.832 152.09C130.492 152.006 131.927 149.665 132.916 147.492C135.674 141.38 136.161 133.446 135.506 126.718C134.921 120.676 132.066 112.321 126.161 111.172",
    stroke: "#FF3239",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.879 111.831C129.879 111.831 131.62 110.85 132.554 107.331C133.487 103.813 138.57 103.673 139.615 107.205C140.966 111.831 140.896 118.209 136.746 126.592",
    stroke: "#FF3239",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1436 148.375H100.088",
    stroke: "#FF3239",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1296 40.4805C95.1296 40.4805 81.8564 39.6955 76.0903 43.1158C75.5611 43.4382 73.7505 43.1298 73.1237 43.1859C70.4496 43.3962 67.7894 43.9429 65.2127 44.7138C56.1875 47.4333 48.3462 53.1525 42.2319 60.3016C38.6664 64.4789 37.2458 68.9225 41.2431 73.4502C42.8169 75.3707 44.3907 77.2911 45.9646 79.2115C49.4744 83.4869 57.1346 93.8321 63.2629 86.8933C63.2629 86.8933 70.3799 80.5713 73.639 70.0159",
    stroke: "#FF3239",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8062 90.58C58.8062 90.58 60.1154 108.242 79.2382 110.878",
    stroke: "#FF3239",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6839 84.8186C81.7915 84.8186 83.5001 83.099 83.5001 80.9778C83.5001 78.8565 81.7915 77.1369 79.6839 77.1369C77.5763 77.1369 75.8677 78.8565 75.8677 80.9778C75.8677 83.099 77.5763 84.8186 79.6839 84.8186Z",
    fill: "#FF3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.737 90.7621L90.8121 87.8184C89.7118 86.711 90.4918 84.8186 92.0517 84.8186H98.2078C99.7677 84.8186 100.548 86.711 99.4474 87.8184L96.5225 90.7621C95.7565 91.5331 94.503 91.5331 93.737 90.7621Z",
    fill: "#FF3239",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7983 94.5189C85.7983 94.5189 89.0992 100.659 94.5868 96.4954V91.8275",
    stroke: "#FF3239",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1299 40.4805C95.1299 40.4805 108.403 39.6955 114.169 43.1158C114.698 43.4382 116.509 43.1298 117.136 43.1859C119.81 43.3962 122.47 43.9429 125.047 44.7138C134.072 47.4333 141.913 53.1525 148.028 60.3016C151.593 64.4789 153.014 68.9225 149.016 73.4502L144.295 79.2115C140.785 83.4869 133.125 93.8321 126.997 86.8933C126.997 86.8933 119.88 80.5713 116.62 70.0159",
    stroke: "#FF3239",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.467 90.58C131.467 90.58 130.158 108.242 111.035 110.878",
    stroke: "#FF3239",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.59 84.8186C112.697 84.8186 114.406 83.099 114.406 80.9778C114.406 78.8565 112.697 77.1369 110.59 77.1369C108.482 77.1369 106.773 78.8565 106.773 80.9778C106.773 83.099 108.482 84.8186 110.59 84.8186Z",
    fill: "#FF3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.475 94.5189C104.475 94.5189 101.175 100.659 95.687 96.4954V91.8275",
    stroke: "#FF3239",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3877 98.8224V109.224",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5551 104.023H28.2207",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2873 92.8508C24.2027 92.8508 25.7554 91.2881 25.7554 89.3604C25.7554 87.4327 24.2027 85.87 22.2873 85.87C20.372 85.87 18.8193 87.4327 18.8193 89.3604C18.8193 91.2881 20.372 92.8508 22.2873 92.8508Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3207 102.579C15.0514 102.579 15.6438 101.983 15.6438 101.247C15.6438 100.512 15.0514 99.9158 14.3207 99.9158C13.5899 99.9158 12.9976 100.512 12.9976 101.247C12.9976 101.983 13.5899 102.579 14.3207 102.579Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.609 108.06L161.605 103.696L157.268 98.6673L152.272 103.032L156.609 108.06Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.465 97.5468L171.12 101.934",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.465 101.934L171.12 97.5468",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.05 88.5754C161.419 88.5754 161.718 88.2741 161.718 87.9025C161.718 87.5309 161.419 87.2297 161.05 87.2297C160.681 87.2297 160.381 87.5309 160.381 87.9025C160.381 88.2741 160.681 88.5754 161.05 88.5754Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7308 207.502C51.7308 202.077 52.6918 195.713 50.2127 190.751C48.1653 186.672 44.0287 185.102 40.4493 182.649C34.3629 178.457 28.2486 174.308 22.19 170.089C17.6496 166.935 13.8333 164.285 11.3681 159.085L11.2706 158.86C8.54079 152.707 5.81095 146.553 3.08111 140.413C1.36799 136.544 -0.359051 132.661 -2.07217 128.792C-3.78528 124.923 -5.63767 121.559 -3.54851 117.312C-1.83539 113.821 1.60477 112.994 5.17027 114.018C8.63829 115.027 10.045 119.989 11.4935 122.919C13.5409 127.04 15.5882 131.161 17.6356 135.269C19.8084 139.642 21.9811 144.016 24.1538 148.389",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5026 207.502C79.5026 196.778 81.0068 184.905 76.4385 174.967C72.3716 166.122 64.9481 161.552 57.1764 156.491C54.544 154.781 51.9117 153.071 49.2933 151.333C43.6943 147.632 34.9755 140.441 28.1648 145.109C28.1648 145.109 19.1257 150.31 28.1648 156.477L47.5384 170.453",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25098 118.055C11.2426 117.466 13.4015 117.368 15.4349 117.732C17.2873 118.069 18.5687 118.461 20.0868 119.625C21.9392 121.04 24.1955 124.601 25.2958 126.704C26.4796 128.975 27.5521 131.301 28.6802 133.6C30.3098 136.923 31.9532 140.245 33.5828 143.567",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7695 127.306C25.7695 127.306 30.491 124.559 35.0872 127.685C38.9591 130.306 45.1709 146.16 46.6612 149.539",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9447 59.2082C19.9615 59.9231 20.9364 60.7081 21.8696 61.5071C23.4573 62.8107 23.9866 64.9695 22.552 67.8151C21.0896 70.7588 19.0283 71.6419 17.0506 71.1093C12.0505 69.8336 6.85545 67.717 2.59355 64.7732C0.908291 63.6798 0.253687 61.0725 2.16179 57.2457C4.04204 53.531 6.4794 52.6058 8.33179 53.3488C9.48779 53.7693 10.6438 54.2459 11.7441 54.8206C12.6355 52.6619 13.9865 50.5031 15.5324 48.835C14.5993 48.008 13.694 47.1809 12.8444 46.2838C11.4377 44.84 11.2427 42.2607 13.6801 39.1768C16.1453 36.0929 18.6523 35.7565 20.3375 36.8499C24.6551 39.6814 28.6942 43.6204 31.9811 47.6295C33.2625 49.2415 33.4018 51.4143 31.5076 53.7833C29.6413 56.1523 27.5103 56.4887 25.6858 55.5495C24.5994 55.0028 23.5409 54.3861 22.4685 53.7693C21.5632 55.6477 20.3097 57.5541 18.9726 59.2082H18.9447Z",
    fill: "white",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5329 44.2092C38.5273 46.0034 36.2153 46.4941 34.5997 45.1624C32.6359 43.3821 30.6303 41.4897 28.6943 39.5413C24.1678 35.1677 22.4965 28.7756 31.8977 21.4584C41.5636 14.5196 46.9815 18.052 49.8924 23.6451C51.2016 26.0702 52.4412 28.5373 53.5415 30.9484C54.3911 32.8548 53.3047 34.9294 51.0484 36.3452C47.7614 38.4339 45.4773 37.0741 44.3631 35.2518C43.2628 36.4153 42.9424 36.6536 41.48 37.4106C42.9006 39.0366 43.5831 41.5458 40.5469 44.2092H40.5329ZM36.0621 30.9344C35.31 31.4951 35.9089 32.238 36.466 31.8455C38.0538 30.6961 39.5162 29.9111 41.4243 29.3924C41.9953 29.2522 42.0511 28.2009 41.299 28.3691C39.5301 28.6074 37.6777 29.7148 36.0621 30.9203V30.9344Z",
    fill: "white",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1792 17.9399C63.9313 20.1968 64.7531 23.2526 65.2266 25.5235C65.6584 27.5281 64.8506 29.4625 62.26 30.5419C59.6137 31.6633 57.6778 30.8643 56.5496 29.1541C53.6526 24.8507 51.0482 19.8463 49.5718 14.87C48.9451 12.9636 49.8643 10.6927 53.3045 9.23489C55.2404 8.42186 56.8282 8.3798 57.9981 8.81435C62.7196 10.4404 65.8116 13.8748 69.6278 16.412C70.0038 16.7905 70.7142 16.3279 70.2128 15.9214C69.1264 14.9962 68.3186 14.4074 67.2322 13.6505C66.8562 11.8983 66.4801 9.99184 66.2851 8.534C66.1319 6.51544 67.3854 4.46885 70.9649 3.66984C74.5443 2.89886 76.5499 4.23055 77.2602 6.12294C78.8758 11.0292 79.6697 16.6222 79.8368 21.7948C79.809 23.8554 78.7365 25.6076 75.9789 26.2104C74.0707 26.6309 72.7337 26.1543 71.6612 25.2852C69.2796 23.3648 66.313 19.8183 63.1792 17.9119V17.9399Z",
    fill: "white",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.11 20.2108C82.1768 15.5849 81.7311 11.4076 81.4944 6.64158C81.369 3.76794 84.4889 1.7634 87.7619 1.38492C89.9625 1.1326 92.5669 0.964387 95.1436 1.00644C105.116 1.1326 111.62 5.84257 109.991 13.7626C108.403 21.7387 102.205 24.6264 94.8233 24.5423C92.8037 24.5002 90.7842 24.4441 89.0293 24.4021C86.5084 24.304 83.7367 22.9723 83.1239 20.1967L83.11 20.2108ZM96.0489 14.2672C97.1074 13.272 97.4835 11.8141 97.5809 10.4824C97.6088 9.83763 96.216 9.80959 96.2021 10.2441C96.0489 11.5618 95.6589 12.6552 94.7258 13.9448C94.4193 14.3373 95.5475 14.7719 96.0489 14.2672Z",
    fill: "white",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.996 21.4023C121.467 22.6218 120.882 23.8554 120.325 25.0609C119.419 26.9112 117.581 27.9345 114.893 27.1916C112.135 26.4487 111.119 24.6404 111.3 22.5938C111.704 17.4352 112.776 12.0524 114.642 7.24433C115.645 4.7772 118.458 4.51087 121.773 5.14167C123.779 5.5622 125.854 6.10889 127.804 6.78174C135.631 9.34699 142.902 14.3653 139.42 20.4631C135.812 26.7991 129.127 23.8694 121.996 21.4163V21.4023ZM124.378 14.4775C125.784 15.5849 127.317 16.3699 129.141 16.9586C130.019 17.225 130.227 16.3278 129.615 16.1036C127.748 15.4447 126.509 14.7578 125.032 13.6925C124.475 13.3 123.681 13.8887 124.378 14.4635V14.4775Z",
    fill: "white",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.133 31.6633C136.983 29.5045 138.125 27.3458 139.476 25.0048C140.827 22.6639 142.108 20.6032 143.626 18.851C145.855 16.1176 152.303 18.9071 157.401 22.9863C162.833 27.1916 167.359 33.1071 164.198 36.0648C162.916 37.2844 161.969 36.7938 159.936 34.0182C159.267 33.1071 158.376 32.0978 157.582 31.3969C155.284 29.3503 153.473 28.299 151.774 27.5701C150.938 27.2056 150.715 28.0186 151.621 28.3971C155.047 29.9251 159.239 33.6117 160.214 35.8966C161.05 37.8451 160.841 39.331 159.379 40.7327C157.916 42.1345 156.468 42.3168 154.671 41.5878C152.554 40.7327 148.975 37.3685 146.83 34.6631C146.259 33.9482 145.604 34.3967 146.105 35.0556C147.122 36.4153 148.39 37.761 150.423 39.5833C151.133 40.2141 152.066 40.929 152.916 41.4897C155.465 43.2139 155.813 44.2091 154.573 45.3866C151.426 48.3304 147.011 44.7699 142.874 41.5177C139.002 38.3497 134.907 34.8453 136.147 31.6492L136.133 31.6633Z",
    fill: "white",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M166.732 45.6951C164.211 42.471 163.71 39.331 165.618 37.5227C167.596 35.6583 170.743 36.6676 173.668 40.13C176.008 42.8915 177.847 45.4568 179.532 48.1061C181.189 50.7274 182.707 53.517 184.267 56.8672C186.259 61.1987 185.966 64.8994 183.571 65.8946C181.161 66.9039 178.362 64.8153 176.412 60.9884C176.189 60.5399 175.952 60.1053 175.73 59.6567C176.245 59.068 176.76 58.269 177.136 57.6242C177.401 57.1055 176.635 56.1103 176.454 56.4887C174.323 60.0633 170.117 62.8528 167.331 64.0583C165.2 64.8433 162.456 64.1705 160.256 60.652C158.069 57.2457 158.584 54.4141 160.214 52.8161C162.442 50.7134 165.089 48.9332 168.445 47.9659C167.888 47.195 167.317 46.438 166.732 45.6951Z",
    fill: "white",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHandpet);
export default __webpack_public_path__ + "static/media/logo-handpet.963dc16291225ec1a3427a9929283098.svg";
export { ForwardRef as ReactComponent };